import { get } from '../../../../resources/frontend/js/mixins/get-page-data';

/**
 * Check if the component should be shown on the current step
 * @param {object} currentStep
 * @param {string} path
 */
export default (currentStep, path) => {
    const getComponent = get(path);

    for (const [key, step] of Object.entries(getComponent['showOnStep'])) {
        if (key === '_info') continue;

        if (currentStep.key === key) {
            return step.value;
        }
    }
};
